"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.Wrapper = exports.TextWrapper = exports.Circle = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = require("@emotion/react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const Wrapper = exports.Wrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1iuee1r2"
} : {
  target: "e1iuee1r2",
  label: "Wrapper"
})(props => /*#__PURE__*/(0, _react.css)("display:grid;grid-template-columns:16px 1fr;grid-column-gap:1em;position:relative;&:after{content:'';position:absolute;width:2px;background-color:", props.theme.border, ";top:16px;bottom:-1.5em;left:calc((16px / 2) - 1px);}" + (process.env.NODE_ENV === "production" ? "" : ";label:Wrapper;")));
const Circle = exports.Circle = /*#__PURE__*/(0, _base.default)("span", process.env.NODE_ENV === "production" ? {
  target: "e1iuee1r1"
} : {
  target: "e1iuee1r1",
  label: "Circle"
})(process.env.NODE_ENV === "production" ? {
  name: "tpvfx3",
  styles: "display:flex;justify-content:center;align-items:center;width:12px;height:12px;border-radius:50%;z-index:1"
} : {
  name: "tpvfx3",
  styles: "display:flex;justify-content:center;align-items:center;width:12px;height:12px;border-radius:50%;z-index:1",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const TextWrapper = exports.TextWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1iuee1r0"
} : {
  target: "e1iuee1r0",
  label: "TextWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "1io3jmd",
  styles: "display:grid;grid-row-gap:0.4em;word-break:break-word"
} : {
  name: "1io3jmd",
  styles: "display:grid;grid-row-gap:0.4em;word-break:break-word",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const styles = exports.styles = {
  defaultCircle: theme => /*#__PURE__*/(0, _react.css)("border:2px solid ", theme.border, ";background-color:transparent;" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultCircle;")),
  active: theme => /*#__PURE__*/(0, _react.css)("border:2px solid ", theme.primary, ";background-color:", theme.primary, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:active;")),
  complete: theme => /*#__PURE__*/(0, _react.css)("border:2px solid ", theme.border, ";background-color:", theme.border, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:complete;"))
};